import {
  Box,
  Chip,
  IconButton,
  Typography,
  Switch,
  Container,
} from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import SyncIcon from "@mui/icons-material/Sync";
import {
  useGetAllDealerSettingsMutation,
  useUpdateDealerSettingsMutation,
} from "../../redux/reducer/features/Dealer/DealerSettingsSlice";
import AppGrid from "../app/AppGrid";

const DealerSettings: React.FunctionComponent = () => {
  const [dealerSettings, setDealerSettings] = useState<any[]>([]);

  const [getAllDealerSettings, getAllDealerSettingsResult] =
    useGetAllDealerSettingsMutation();
  const [updateDealerSettings, updateDealerSettingsResult] =
    useUpdateDealerSettingsMutation();

  const fetchAllSettings = async () => {
    try {
      const response = await getAllDealerSettings().unwrap();

      if (response.status === 200) {
        setDealerSettings(response.entityList || []);
      } else {
        setDealerSettings([]);
      }
    } catch (err: any) {
      setDealerSettings([]);
    }
  };

  const handleSwitchChange = async (
    dmsDealerId: number,
    currentValue: boolean
  ) => {
    try {
      await updateDealerSettings({
        dmsDealerId: dmsDealerId,
        hasMultipleSite: !currentValue,
      }).unwrap();

      fetchAllSettings();
    } catch (err: any) {
      fetchAllSettings();
    }
  };

  useEffect(() => {
    fetchAllSettings();
  }, []);

  const columns: GridColDef[] = [
    {
      field: "dmsDealerId",
      headerName: "DMS Dealer ID",
      width: 200,
      editable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params?.row?.dmsDealerId || "N/A",
    },
    {
      field: "hasMultipleSite",
      headerName: "Has Multiple Sites",
      width: 200,
      type: "actions",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Switch
              checked={params?.row?.hasMultipleSite}
              onChange={() =>
                handleSwitchChange(
                  params?.row?.dmsDealerId,
                  params?.row?.hasMultipleSite
                )
              }
              color="primary"
              size="small"
              disabled={updateDealerSettingsResult.isLoading}
            />
            <Chip
              label={params?.row?.hasMultipleSite ? "Yes" : "No"}
              color={params?.row?.hasMultipleSite ? "success" : "default"}
              size="small"
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Container maxWidth={false}>
      <Box display="flex" alignItems="center">
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Dealer Settings
        </Typography>
        <IconButton onClick={() => fetchAllSettings()}>
          <SyncIcon />
        </IconButton>
      </Box>

      <AppGrid
        data={[...dealerSettings].sort((a: any, b: any) => {
          return (
            (b.hasMultipleSite === true ? 1 : 0) -
            (a.hasMultipleSite === true ? 1 : 0)
          );
        })}
        isLoading={
          updateDealerSettingsResult.isLoading ||
          getAllDealerSettingsResult.isLoading
        }
        columns={columns}
        checkBox={true}
      ></AppGrid>
    </Container>
  );
};

export default DealerSettings;
